import React, { useState } from 'react'
import _ from 'lodash'
import { Query } from 'react-apollo'
import { useMutation } from '@apollo/react-hooks'
import ReactTable from 'react-table'
import {
  Modal, DatePicker, message,
} from 'antd'
import {
  Div, H3, Loading, P, DynamicButtonLink, Button,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import './style-css.css'
import { Wrapper } from '../../../components/truckowner-components'
import { GET_TRUCK_OWNER } from '../../../constants/graphql/query'
import { SYNC_TRUCK_OWNER_REPORT, CONFIRM_SYNC_TRUCK_OWNER_REPORT } from '../../../constants/graphql/mutation'
import PERMISSION from '../../../constants/permissions'

const { color } = theme


const mappingAnotherModelValue = v => ({ [v.id]: v.value })
const mappingOrderAnotherModel = sortValue => ({ id: sortValue.id, desc: sortValue.desc })

const SyncModal = ({
  syncModal, setSyncModal, setConfirmModal, month, setMonth, setList,
}) => {
  const [doAction, { loading }] = useMutation(SYNC_TRUCK_OWNER_REPORT)
  return (
    <Modal
      title="เลือกเดือน"
      visible={syncModal}
      destroyOnClose={true}
      onCancel={() => {
        setSyncModal(false)
        setMonth()
      }}
      onOk={() => {
        doAction({
          variables: { month },
        }).then(({ data }) => {
          const resp = data.SyncTruckownerReport
          if (resp.success) {
            if (resp.syncSuccess) {
              message.success(resp.message)
              setMonth()
            } else {
              setConfirmModal(true)
              setList(resp.notReadyList)
            }
          } else message.error(resp.message)
        })
        setSyncModal(false)
      }}
      okButtonProps={{
        disabled: loading || _.isUndefined(month),
        loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row' justifyContent='space-between'>
        <P margin = '0 32px 0 0'>เลือกเดือน</P>
        <DatePicker.MonthPicker
          format='MM/YYYY'
          onChange={(e) => {
            setMonth(e)
          }}
        />
      </Div>
    </Modal>
  )
}

const ConfirmModal = ({
  confirmModal, setConfirmModal, month, setMonth, list, setList,
}) => {
  const [doAction, { loading }] = useMutation(CONFIRM_SYNC_TRUCK_OWNER_REPORT)
  return (
    <Modal
      title="ยืนยันบันทึกค่าใช้จ่ายรถร่วมในPEAK"
      visible={confirmModal}
      destroyOnClose={true}
      onCancel={() => {
        setConfirmModal(false)
        setMonth()
        setList([])
      }}
      onOk={() => {
        doAction({
          variables: { month },
        }).then(({ data }) => {
          const resp = data.ConfirmSyncTruckownerReport
          if (resp.success) {
            message.success(resp.message)
          } else message.error(resp.message)
        })
        setConfirmModal(false)
        setMonth()
        setList([])
      }}
      okButtonProps={{
        disabled: loading || _.isUndefined(month),
        loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div display='flex' flexDirection='column'>
        <P margin='0 0 16px'>มีเจ้าของรถร่วมที่ยังไม่ได้บันทึกค่าใช้จ่าย จำนวน {list.length} รายการ</P>
        {
          _.map(list, (v, i) => (
            <Div margin='0 0 16px' alignItems='center' display='flex' flexDirection='row' >
              <P margin='0 8px 0 0 '>{i + 1}.</P>
              <P>{v.nameTh}</P>
            </Div>
          ))
        }
      </Div>
    </Modal>
  )
}

const Index = () => {
  const [month, setMonth] = useState()
  const [syncModal, setSyncModal] = useState(false)
  const [confirmModal, setConfirmModal] = useState(false)
  const [list, setList] = useState([])
  return (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รายการเจ้าของรถบรรทุก</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between'>
        <Button
          text='บันทึกค่าใช้จ่ายรถร่วมในPEAK'
          onClick={() => {
            setSyncModal(true)
          }}
          margin='0 16px 0 0'
        />
        <DynamicButtonLink link='/truckowner/add' condition={_.includes(window.perms, PERMISSION.CREATE_TRUCK)} props={{ text: 'เพิ่มเจ้าของรถบรรทุก' }}></DynamicButtonLink>
      </Div>
    </Div>
    <SyncModal syncModal={syncModal} setSyncModal={setSyncModal} setConfirmModal={setConfirmModal} month={month} setMonth={setMonth} setList={setList}/>
    <ConfirmModal confirmModal={confirmModal} setConfirmModal={setConfirmModal} month={month} setMonth={setMonth} list={list} setList={setList}/>
    <List />
  </Div>
  )
}

export const List = () => {
  const [filtered, setFiltered] = useState([])
  const [sorted, setSorted] = useState([{ id: 'createdAt', desc: true }])
  const [current, setCurrent] = useState(0)
  return (
    <Wrapper overflow padding='0 0 40px 0' center>
      <Query
        query={GET_TRUCK_OWNER}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({
        data, error, loading, refetch,
      }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        const {
          TruckownerList: {
            lists,
            totalFilter,
          },
        } = data
        return (
          <ReactTable
            className='table'
            data={lists} // *
            resizable={false}
            columns={config.columns} // *
            minRows={5}
            manual
            showPageSizeOptions={false}
            getTdProps={ () => ({ disabled: false, refetch })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.secondaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            noDataText='ไม่พบข้อมูล'
            page={current}
            pages={Math.ceil((totalFilter || 0) / 5)}
            onPageChange={page => setCurrent(page)}
            onFilteredChange={async (newFiltered) => {
              const mapObj = newFiltered.map(v => mappingAnotherModelValue(v))
                .reduce((prev, curr) => ({ ...prev, ...curr }), {})
              setFiltered(mapObj)
              setCurrent(0)
            }}
            onSortedChange={async (newSorted) => {
              const sortValue = newSorted[0]
              const mappingNewSort = mappingOrderAnotherModel(sortValue)
              setSorted([mappingNewSort])
              setCurrent(0)
            }}
          />
        )
      }}
      </Query>
    </Wrapper>
  )
}

export default Index
